import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@node_modules/@angular/common';
import { TokenService } from 'abp-ng2-module';
import { environment } from 'environments/environment';

@Injectable()
export class CustomTokenService extends TokenService {
  constructor(@Inject(DOCUMENT) private doc: Document) {
    super();
  }

  override getToken(): string {
    const cookieName = environment.production ? 'Abp.AuthToken' : 'Abp.DevAuthToken';

    const cookies = this.doc.cookie
      .split('; ')
      .map(c => c.split('='))
      .reduce((acc, [k, v]) => {
        acc[k] = decodeURIComponent(v);
        return acc;
      }, {} as Record<string, string>);

    return cookies[cookieName] || '';
  }

  override getTokenCookieName(): string {
    return environment.production ? 'Abp.AuthToken' : 'Abp.DevAuthToken';
  }
}
